"use client";

/**
 * Records the page the user is on, so a purchase they start later can send them
 * back to it. Mounted once in the root layout; renders nothing.
 *
 * One root-mounted listener rather than a `?returnTo=` appended at every CTA,
 * for the same reason <TrialConvertHost/> is an event listener rather than a
 * modal at ~22 call sites: about twenty places route to /pricing, and half of
 * them are `router.push` soft navigations, which leave `document.referrer`
 * pointing at whatever loaded the document — often nothing at all. A rule that
 * has to be remembered at twenty call sites gets missed at some of them, and
 * the ones it gets missed at are the ones nobody tests.
 *
 * Buying surfaces record nothing (see SELLING_PATHS), so arriving at /pricing
 * leaves the page BEFORE it intact — which is the whole point.
 */

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { rememberPurchaseOrigin } from "@/lib/billing/purchase-return-path";

export function PurchaseOriginRecorder() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;
    // The pathname alone, never the query — some of this app's query strings
    // are instructions (`?prompt=` starts a build), and replaying one after a
    // payment would do something the buyer never asked for.
    rememberPurchaseOrigin(pathname);
  }, [pathname]);

  return null;
}
